import request from "@/utils/request";

export default function agentEnableRfIdCard(id) {
  return request({
    url: `/user/agent/RFIDCardController/enableRfIdCard?id=${id}`,
    method: "post",
  });
}
